import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Drag6 = (props) => (
  <Icon viewBox="0 0 6 10" {...props}>
    <g>
      <path d="M0 0h2v2H0zm0 4h2v2H0zm0 4h2v2H0zm4-8h2v2H4zm0 4h2v2H4zm0 4h2v2H4z" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Drag6;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Drag6.js